import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { ElementosVinculadosInterface } from 'app/models/elementos-vinculados-model';
import { Observable } from 'rxjs';
import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { CONSTANTS } from 'app/core/constants';

@Component({
    selector: 'elementos-vinculados',
    templateUrl: 'elementos-vinculados.html',
    imports:[
        CommonModule,
        MatTableModule,
        MatIconModule
    ]
})

export class ElementosVinculadosComponent implements OnInit {
    
    @Input() elementosVinculados:ElementosVinculadosInterface[]
    @Input() link:string

    actividesTableColumns: string[] = [
        'tipo',
        'nombre',
        'referencia',
        'link'
    ];

    constructor(private router: Router) {

    }

    ngOnInit() { }

    openTaskDetails(task: ElementosVinculadosInterface){
        if(task.tipoEntidad.tipologiaId=== CONSTANTS.TIPOLOGIA_ID_TIPO_ENTIDAD_DOCUMENTO_GENERADO){
            this.router.navigateByUrl(`documentos-oficiales/detalle/${task.entidadUuid}`)
           
        }
        else if(task.tipoEntidad.tipologiaId=== CONSTANTS.TIPOLOGIA_ID_TIPO_ENTIDAD_BIEN_CULTURAL){
             this.router.navigateByUrl(`bienes-culturales/detalle/${task.entidadUuid}`)
        }
        else{
            this.router.navigateByUrl(`${this.link}/${task.entidadUuid}`)
        }
        
    }
}